import { defineStore } from "pinia";
import { ref } from "vue";

export const useUiStore = defineStore("ui", () => {
  const loading = ref(false);
  const modalState = ref(false);
  const modalData = ref(null);
  const modalAction = ref(null);
  const isCollapsed = ref(false);

  function setLoading(value) {
    loading.value = value;
  }

  function setModalState(value) {
    modalState.value = value;
  }

  function setModalData(value) {
    modalData.value = value;
  }

  function setModalAction(value) {
    modalAction.value = value;
  }

  function resetModalStore() {
    modalData.value = null;
    modalState.value = false;
    modalAction.value = null;
  }

  function updateCollapseState(value) {
    isCollapsed.value = value;
  }

  return {
    loading,
    modalState,
    modalData,
    modalAction,
    isCollapsed,
    setLoading,
    setModalState,
    setModalData,
    setModalAction,
    resetModalStore,
    updateCollapseState,
  };
});
